

























import Vue from "vue";

interface Props {
  decrease: boolean;
  increase: boolean;
  learnStatus: number;
  msgLearned: string;
  msgNew: string;
}

export default Vue.extend<Props>({
  name: "JzDrillQuestionBase",
  functional: true,

  props: {
    decrease: { type: Boolean, default: false },
    increase: { type: Boolean, default: false },
    learnStatus: { type: Number, required: true },
    msgLearned: { type: String, default: "learned" },
    msgNew: { type: String, default: "new" }
  }
});
